import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import Link from "../components/Link";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";
import renderButtons from "../helpers/renderButtons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const StlRoot = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  background: ${colors.heroOrange};
`;

const StlBackgroundImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: ${(props) =>
    props.imageUrl ? `url(${props.imageUrl})` : "none"};
  background-size: cover;
  background-position: center top;

  @media (min-width: 900px) {
    background-position: center;
  }
`;

const StlGradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(199, 106, 60, 0.98) 0%,
    rgba(199, 106, 60, 0.98) 10%,
    rgba(199, 106, 60, 0.9) 24%,
    rgba(199, 106, 60, 0.76) 45%,
    rgba(199, 106, 60, 0.48) 68%,
    rgba(199, 106, 60, 0.18) 100%
  );

  @media (min-width: 900px) {
    background:
      linear-gradient(
        90deg,
        rgba(199, 106, 60, 1) 0%,
        rgba(199, 106, 60, 0.81) 22%,
        rgba(199, 106, 60, 0.5) 42%,
        rgba(199, 106, 60, 0.24) 60%,
        rgba(199, 106, 60, 0.12) 96%,
        rgba(199, 106, 60, 0.06) 100%
      ),
      linear-gradient(
        180deg,
        rgba(223, 148, 103, 0.24) 0%,
        rgba(223, 148, 103, 0.24) 100%
      );
  }
`;

const StlInner = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
  min-height: 640px;
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 900px) {
    min-height: 690px;
    grid-template-columns: 1fr 1fr;
  }
`;

const StlCopySection = styled.div`
  padding: 36px 24px 48px;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  h3 {
    margin: 0;
  }

  @media (min-width: 900px) {
    justify-content: flex-start;
    align-items: center;
    padding: 170px 72px 90px;
  }
`;

const StlCopyInner = styled.div`
  width: 100%;
  max-width: 520px;
  text-align: center;
  color: ${colors.white};

  @media (min-width: 900px) {
    text-align: left;
  }

  h1,
  h2,
  p {
    margin: 0 0 18px;
  }

  h1,
  h2 {
    margin-bottom: 24px;
    color: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: inherit;
  }

  p {
    font-size: 4.2rem;
    line-height: 4.8rem;
    letter-spacing: -0.12rem;
  }
`;

const StlButtonWrap = styled.div`
  margin-top: 28px;

  @media (min-width: 900px) {
    margin-top: 32px;
  }
`;

const GradientInfo = (slice) => {
  const theme = useTheme();
  const copy = get(slice, "primary.copy");
  const subCopy = get(slice, "primary.sub_copy");
  const imageUrl = get(slice, "primary.image.url");
  const mobileImageUrl = get(slice, "primary.image.Mobile.url");
  const buttons = get(slice, "items");
  const isTablet = useMediaQuery(theme.breakpoints.down("800"));

  if (!copy && !imageUrl) {
    return null;
  }

  return (
    <StlRoot>
      <StlBackgroundImage imageUrl={isTablet ? mobileImageUrl : imageUrl} />
      <StlGradientOverlay />
      <StlInner>
        <StlCopySection>
          <StlCopyInner>
            {copy && <PrismicRichText render={copy} />}
            {subCopy && <PrismicRichText render={subCopy} />}
            <StlButtonWrap>{renderButtons(buttons)}</StlButtonWrap>
          </StlCopyInner>
        </StlCopySection>
      </StlInner>
    </StlRoot>
  );
};

export default GradientInfo;
